import React, {Component, createRef} from 'react'
import PropsTypes from 'prop-types'
import {Badge} from "reactstrap"
import Clipboard from "clipboard"
import {_deleteWorker, _requestLoginAccount} from "../../../../../services/apis/WorkerServices"
import timeHuman from "../../../../../helpers/time/timeHuman"

const badgeColorMap = {
    active: 'success',
    checkpoint: 'warning',
    wrong_pass: 'warning',
    logout: 'danger',
    disabled: 'danger',
}

class WorkerRecord extends Component {
    _button = createRef()

    state = {
        loadingLogin: false
    }

    componentDidMount() {
        this._initClipboard()
    }

    componentWillUnmount() {
        this._destroyClipboard()
    }

    _destroyClipboard = () => {
        if (this._clipboard) {
            this._clipboard.destroy()
        }
    }

    _initClipboard = () => {
        if (this.initClipboard) return

        if (this._button.current) {
            this.initClipboard = true
            this._clipboard = new Clipboard(this._button.current)
        }
    }

    _requestLogin = () => {
        this.setState({
            loadingLogin: true
        })

        const {device, record} = this.props

        _requestLoginAccount(record._id, device)
            .then(response => {
                this.setState({
                    loadingLogin: false
                })
            })
            .catch(error => {
                this.setState({
                    loadingLogin: false
                })
            })
    }

    _deleteWorker = () => {
        const {_id} = this.props.record
        this.props.removeWorkerFormState(_id)
        _deleteWorker(_id)
            .then(result => {
                if (result.success) {
                    this.props.onRefreshPage()
                }
                console.log(result)

            })
    }

    _handleClickLogin = (e) => {
        e.preventDefault()
        this._requestLogin()
    }

    _handleClickEdit = () => {
        this.props.onChangeModalData(this.props.record)
        this.props.onToggleModal()
    }

    _handleCopySecretCode = () => {
        const {record} = this.props
        const secretCode = record.secretCode || ''
        navigator.clipboard.writeText(secretCode)
            .then(() => {

            })
    }

    render() {
        const {order, record} = this.props
        const {username, proxy, status, password, score, country, note, created, _id} = record
        const {loadingLogin} = this.state

        return (
            <div className='WorkerRecord' id={`W-${_id}`}>
                <div className='row table-row'>
                    <div className="Order col">{order}</div>
                    <div className='Score col'>{score}</div>
                    <div className='col'>
                        <span title={timeHuman(created)}>{username} </span>
                        {
                            !!country &&
                            <Badge color="info" pill>{country}</Badge>
                        }
                    </div>
                    <div className='col'>
                        <button ref={this._button}
                                className='btn btn-primary'
                                data-clipboard-text={password}>
                            Copy
                        </button>
                    </div>
                    <div className='col'>
                        <button className="btn btn-primary"
                                onClick={this._handleCopySecretCode}>
                            Copy
                        </button>
                    </div>
                    <div className="Note col">
                        {note}
                    </div>
                    <div className='col'>{proxy}</div>
                    <div className='col'><Badge color={badgeColorMap[status]} pill>{status}</Badge></div>
                    <div className='col'>
                        <div className="Actions d-flex flex-row">
                            <div className="Action">
                                <button className='btn btn-success' disabled={loadingLogin}
                                        onClick={this._handleClickLogin}>
                                    <i className="fas fa-sign-in-alt"/>
                                </button>
                            </div>

                            <div className="Action">
                                <button className='btn btn-primary' onClick={this._handleClickEdit}>
                                    Edit
                                </button>
                            </div>

                            <div className="Action">
                                <button className='btn btn-danger' onClick={this._deleteWorker}>
                                    <i className="fas fa-times"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

WorkerRecord.propsTypes = {
    onChangeModalData: PropsTypes.func.isRequired,
    onToggleModal: PropsTypes.func.isRequired,
    removeWorkerFormState: PropsTypes.func.isRequired,
    onRefreshPage: PropsTypes.func.isRequired,
    record: PropsTypes.object.isRequired,
    device: PropsTypes.string.isRequired,
    order: PropsTypes.number.isRequired,
}

export default WorkerRecord



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/WorkerRecord.js